import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";
import { InitialUserFormData } from "../../ConstantData/InitialData";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    userList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    initialData: InitialUserFormData,
  },
  reducers: {
    getAllUser: (state, action) => {
      state.userList = action.payload;
    },
    getUser: () => {},
    getUserDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;

      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialUserFormData };
    },
    createUser: () => {},
    updateUser: () => {},
    deleteUser: () => {},
  },
});
export const userSliceAction = userSlice.actions;
export default userSlice.reducer;
